module.exports = __webpack_public_path__ + "static/media/pin.28111923.png";